import toast from "react-hot-toast";
import * as api from "../Api";

export const createLocationAdvice = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("adding new location...");
    const { data } = await api.createLocation(postData);
    dispatch({ type: "CREATE_LOCATION", payload: data });
    toast.remove(creatingId);
    toast.success("location added successfully");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};

export const getAllLocation = () => async (dispatch) => {
  try {
    const { data } = await api.getAdviceLocation();
    dispatch({ type: "GET_ALL_LOCATION", payload: data });
  } catch (error) {}
};

export const deleteAdviceLocation = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("deleting location....");
    await api.deleteAdviceLocation(id);
    dispatch({ type: "DELETE_LOCATION", payload: id });
    toast.remove(deletingId);
    toast.success("Location deleted successfully");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
